import { useEffect, useState } from "react";
import { baseUrl } from "../helpers/helpers";
import { chemistMenuGroupOverview, ROLEID } from "../menu";
import { generateToken } from "../notification/firebase";

const useStore = () => {
  const [loader, setLoader] = useState(true);
  const [token, setToken] = useState("");
  const [profile, setProfile] = useState({});
  const [firebaseToken, setFirebaseToken] = useState("");
  const allRoles = [
    { label: "Admin", value: ROLEID.ADMIN },
    { label: "Manager", value: ROLEID.MANAGER },
    { label: "Team-Leader", value: ROLEID.TEAM_LEADER },
    { label: "User", value: ROLEID.USER },
  ];

  useEffect(() => {
    const refresh = async () => {
      try {
        const res = await fetch(`${baseUrl.url}/auth/refresh`, {
          method: "GET",
          credentials: "include",
        });
        const resData = await res.json();
        if (res.ok) {
          setToken(resData.access_token);
          setLoader(false);
        }
        setLoader(false);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };
    if (!token) {
      refresh().then();
    }

    const interval = setInterval(refresh, 14 * 60 * 1000);
    return () => clearInterval(interval);
  }, [setLoader, token]);

  useEffect(() => {
    if (!token) {
      return;
    }
    const ROLES = [
      {
        ID: 1,
        ROLE: "Admin",
        PERMISSION: "All",
      },
      {
        ID: 2,
        ROLE: "Manager",
        PERMISSION: [
          chemistMenuGroupOverview.dashboard.path,
          chemistMenuGroupOverview.data.subMenu.prescriptions.path,
          chemistMenuGroupOverview.data.subMenu.doctor_visit.path,
          chemistMenuGroupOverview.data.subMenu.entity.path,
          chemistMenuGroupOverview.data.subMenu.entity.path,
          chemistMenuGroupOverview.data.subMenu.reportingData.path,
          chemistMenuGroupOverview.reporting.subMenu.top_products.path,
          chemistMenuGroupOverview.reporting.subMenu.top_prescription.path,
          chemistMenuGroupOverview.reporting.subMenu.top_visit.path,
        ],
      },
      {
        ID: 4,
        ROLE: "Team Leader",
        PERMISSION: [
          chemistMenuGroupOverview.dashboard.path,
          chemistMenuGroupOverview.data.subMenu.prescriptions.path,
          chemistMenuGroupOverview.data.subMenu.doctor_visit.path,
          chemistMenuGroupOverview.data.subMenu.reportingData.path,
          chemistMenuGroupOverview.data.subMenu.entity.path,
          chemistMenuGroupOverview.data.subMenu.entity.path,
          chemistMenuGroupOverview.reporting.subMenu.top_products.path,
          chemistMenuGroupOverview.reporting.subMenu.top_prescription.path,
          chemistMenuGroupOverview.reporting.subMenu.top_visit.path,
          chemistMenuGroupOverview.reporting.subMenu.team_leader_overview.path,
        ],
      },
    ];
    const getProfile = async () => {
      try {
        const res = await fetch(`${baseUrl.url}/api/current_user`, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });
        const data = await res.json();
        if (res.ok) {
          const roleData = ROLES?.find(
            (role) => role?.ROLE === data?.data?.role
          );
          setProfile({
            ...data?.data,
            permission: roleData?.PERMISSION,
          });
        } else {
          // eslint-disable-next-line no-console
          console.log(data.error[0]);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };
    getProfile().then();
  }, [token, setProfile]);

  useEffect(() => {
    const getToken = async () => {
      const fToken = await generateToken();
      setFirebaseToken(fToken);
    };
    getToken().then();
  }, []);

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalLength, setTotalLength] = useState(10);
  const [notificationsList, setNotificationsList] = useState([]);
  const [notificationUpdate, setNotificationUpdate] = useState(false);

  useEffect(() => {
    if (!token) {
      return;
    }
    const getMyNotification = async () => {
      try {
        const res = await fetch(
          `${baseUrl.url}/api/own_notification?page=${
            currentPage - 1
          }&size=${perPage}&sort=-id`,
          {
            method: "GET",
            headers: {
              Authorization: `bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const resData = await res.json();
        if (res.ok) {
          setNotificationsList(resData?.data?.items);
          setTotalLength(resData?.data?.total);
        } else {
          setNotificationsList([]);
          setTotalLength(0);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      } finally {
        setLoading(false);
      }
    };
    getMyNotification().then();
  }, [currentPage, perPage, notificationUpdate, token]);

  return {
    loader,
    setLoader,
    token,
    setToken,
    profile,
    loading,
    notificationsList,
    totalLength,
    firebaseToken,
    notificationUpdate,
    setNotificationUpdate,
    setPerPage,
    setCurrentPage,
    allRoles,
  };
};

export default useStore;
